import { QueryClient } from '@tanstack/react-query'
import { INotificationContentHandler } from '@/lib/handler/notification-content-handler'
import { NotificationType } from '@/types/notification'
import { DashboardResponseType } from '@/types/dashboard'

/**
 * Job Applications Content Handler
 * When a new job application notification arrives via WebSocket:
 * - Updates the dashboard cache directly (increments unreadJobApplications) — no API refetch
 * - Invalidates the job-applications list only if it's currently active (page is open)
 */
export default class JobApplicationsContentHandler implements INotificationContentHandler {
  handle(_notification: NotificationType, queryClient: QueryClient): void {
    queryClient.setQueryData<DashboardResponseType>(['dashboard'], old => {
      if (!old?.stats) {
        return old
      }
      return {
        ...old,
        stats: {
          ...old.stats,
          unreadJobApplications: (old.stats.unreadJobApplications ?? 0) + 1
        }
      }
    })

    void queryClient.invalidateQueries({
      queryKey: ['job-applications'],
      refetchType: 'active'
    })
  }
}
